import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'

export class GetInstantOfferSellerRequest extends ValueObject {
  /**
   * @param {String} bodyTypeDoors
   * @param {String} condition
   * @param {String} dealerType
   * @param {String} email
   * @param {Number} fuelId
   * @param {String} licensePlate
   * @param {Number} makeId
   * @param {String} makeName
   * @param {Number} mileage
   * @param {Number} modelId
   * @param {String} modelName
   * @param {String} name
   * @param {String} phone
   * @param {Number} postalCode
   * @param {Number} transmissionTypeId
   * @param {Number} versionId
   * @param {String} versionName
   * @param {Number} year
   */

  getRequest() {
    const {VEHICLE_TYPE: vehicleType} = ConfigContext.get('c2b')

    const request = {
      bodyTypeDoors: this._bodyTypeDoors,
      dealerType: this._dealerType,
      email: this._email,
      fuelId: this._fuelId,
      makeId: this._makeId,
      makeName: this._makeName,
      mileage: this._mileage,
      modelId: this._modelId,
      modelName: this._modelName,
      phone: this._phone,
      postalCode: this._postalCode,
      transmissionTypeId: this._transmissionTypeId,
      vehicleType,
      versionId: this._versionId,
      versionName: this._versionName,
      year: this._year
    }

    if (this._condition) {
      request.condition = this._condition
    }
    if (this._licensePlate) {
      request.licensePlate = this._licensePlate
    }

    if (this._name) {
      request.name = this._name
    }

    return request
  }

  getUpdateRequest() {
    const request = {
      licensePlate: this._licensePlate,
      zipCode: this._postalCode
    }

    if (this._condition) {
      request.condition = this._condition
    }

    return request
  }
}
